import DIApi from './_diApi';
import httpClient from '@/apis/base/httpclient';
import { FormMultiPart } from '@/apis/base/httpclient';

class DictionaryPresentAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'ExplanationForms';

  /**
   * Lấy danh sách lĩnh vực của thuyết minh
   * @param {*} param
   * @returns
   */
  async getByFilter(param) {
    const request = {
      url: this.getAPIUrl(),
      data: param,
    };
    return await httpClient.getAsync(request);
  }

  /**
   * update lại cấu hình 
   * @param {*} param
   * @returns
   */
  async setupExplanationForm(file, src, nameFile, headerInfor, dataSourceDefault) {
    if (!src) {
      src = "";
    }
    let param = {
      file: file,
      url: src,
      fileName: nameFile,
      explanation_form_id: nameFile,
      header_info: headerInfor,
      data_source_default: dataSourceDefault
    }
    const request = {
      url: this.getAPIUrl() + '/setup',
      data: param,
    };
    return await httpClient.putAsync(request);
  }

  /**
   * update lại cấu hình 
   * @param {*} param
   * @returns
   */
  async getData() {
    const request = {
      url: this.getAPIUrl() + '/allData'
    };
    return await httpClient.getAsync(request);
  }

  /**
   * update lại cấu hình 
   * @param {*} param
   * @returns
   */
  async getDataPreview(id) {
    const request = {
      url: this.getAPIUrl() + '/preview/' + id
    };
    return await httpClient.getAsync(request);
  }

  /**
   * Lấy dữ liệu MLNS cho thuyết minh
   * @param {*} param 
   * @returns 
   */
  async getDictionaryNames(payload) {
    const request = {
      url: this.getAPIUrl() + '/DictionaryNames',
      data: payload,
    };
    return await httpClient.postAsync(request);
  }
}

export default new DictionaryPresentAPI();
